/* src/app/stocking/extra-delivery/extra-delivery.component.css */
.header-color {
  background-color: var(--custom-color);
  color: white;
}
/*# sourceMappingURL=extra-delivery.component.css.map */
